<template>
  <div
    v-if="!form.isHidden(name)"
    :class="[cls, form.errors.has(name) ? 'has-error' : '']"
    :style="style"
    :id="(id ? id : name) + '-div'"
  >
    <slot name="label">
      <template v-if="hasLabel">
        <label class="control-label" :for="id ? id : name">
          <span v-html="display"></span>
          <template v-if="required">
            <span class="visible-hidden">Required</span>
            <span class='important' aria-hidden="true">*</span>
          </template>
          
          <template v-if="tooltip">
            <i
              class="fa fa-question-circle"
              aria-hidden="true"
              data-toggle="tooltip"
              data-placement="top"
              :data-original-title="tooltip"
            ></i>
          </template>
        </label>
      </template>
    </slot>
    <div>
      <slot name="input">
        <template v-if="htmlEditor">
          <kr-editor
            v-model="value"
            :options="{
              min_height: htmlEditorHeight,
              max_height: htmlEditorHeight,
            }"
          >
          </kr-editor>
        </template>
        <template v-else-if="type == 'email'">
          <!--class="fills"-->
          <div :class="{ 'input-group': hasAddOnSlot }">
            <input
              @change="emit"
              :id="id ? id : name"
              :name="nameLabel"
              :disabled="form.isDisabled(name)"
              type="email"
              :maxlength="maxlength"
              :placeholder="placeholder"
              :autofocus="autofocus"
              class="form-control"
              v-model="value"
              @keydown="form.errors.clear($event.target.name)"
              @keyup.tab=" isTabbed = true"
              @keydown.tab=" isTabbed = false"
              @click="isTabbed = false"
              @keyup="keyup"
              :class="{ 'isTabbed': isTabbed, name }"
              @paste="
                form.errors.clear($event.target.name);
                keyup;
              "
              @blur="blur"
            />
            <!--<span v-show="form.errors.has(name)"><i style="color:#b40020;" class="fa fa-times-circle"></i></span>-->
            <!--<span><i style="color:#47a647;" class="fa fa-check-circle"></i></span>-->
            <div class="input-group-addon" v-if="hasAddOnSlot">
              <slot name="addon"> </slot>
            </div>
          </div>
        </template>
        <template v-else-if="type == 'text'">
          <!--class="fills"-->
          <div :class="{ 'input-group': hasAddOnSlot }">
            <input
              @change="emit"
              :id="id ? id : name"
              :name="nameLabel"
              :disabled="form.isDisabled(name)"
              type="text"
              :maxlength="maxlength"
              :placeholder="placeholder"
              :autofocus="autofocus"
              class="form-control"
              v-model="value"
              @keydown="form.errors.clear($event.target.name)"
              @keyup.tab=" isTabbed = true"
              @keydown.tab=" isTabbed = false"
              @click="isTabbed = false"
              @keyup="keyup"
              :class="[{ 'isTabbed': isTabbed }, name]"
              @paste="
                form.errors.clear($event.target.name);
                keyup;
              "
              @blur="blur"
            />
            <!--<span v-show="form.errors.has(name)"><i style="color:#b40020;" class="fa fa-times-circle"></i></span>-->
            <!--<span><i style="color:#47a647;" class="fa fa-check-circle"></i></span>-->
            <div class="input-group-addon" v-if="hasAddOnSlot">
              <slot name="addon"> </slot>
            </div>
          </div>
        </template>
        <template v-else-if="type == 'password'">
          <div :class="{ 'input-group': hasAddOnSlot }">
            <input
              @change="emit"
              :id="id ? id : name"
              :name="nameLabel"
              :disabled="form.isDisabled(name)"
              type="password"
              :maxlength="maxlength"
              :placeholder="placeholder"
              class="form-control"
              v-model="value"
              @keydown="form.errors.clear($event.target.name)"
              @keyup="keyup"
              :class="name"
              @paste="
                form.errors.clear($event.target.name);
                keyup;
              "
              @blur="blur"
            />
            <div class="input-group-addon" v-if="hasAddOnSlot">
              <slot name="addon"> </slot>
            </div>
          </div>
        </template>
        <template v-else-if="type == 'text-area'">
          <textarea
            @change="emit"
            :id="id ? id : name"
            :name="nameLabel"
            :disabled="form.isDisabled(name)"
            style="min-height:60px"
            :maxlength="maxlength"
            :rows="rows"
            :placeholder="placeholder"
            class="form-control"
            v-model="value"
            @keydown="form.errors.clear($event.target.name)"
            @keyup="keyup"
            @paste="
              form.errors.clear($event.target.name);
              keyup;
            "
            @blur="blur"
          />
        </template>
        <template v-else-if="type == 'number'">
          <div :class="{ 'input-group flex': hasAddOnSlot }">
            <div class="numberInput">
              <input
                @change="emit"
                :class="[name, {'fixedWidthNumber': dateWidth}]"
                :id="id ? id : name"
                :name="nameLabel"
                :disabled="form.isDisabled(name)"
                type="number"
                :placeholder="placeholder"
                class="form-control"
                v-model="value"
                @keydown="isNumber($event);form.errors.clear($event.target.name)"
                @blur="blur"
              />

              <span class="quantity-nav">
                <div
                  class="quantity-button quantity-up"
                  @click="quantityUp"
                  :class="{ disabled: value == max || form.isDisabled(name) }"
                  aria-label="Increase Value"
                >
                  <i class="fas fa-plus" aria-hidden="true"></i>
                </div>
                <div
                  class="quantity-button quantity-down"
                  @click="quantityDown"
                  :class="{ disabled: value == min || form.isDisabled(name) }"
                  aria-label="Decrease Value"
                >
                  <i class="fas fa-minus" aria-hidden="true"></i>
                </div>
              </span>
            </div>
            <div
              class="input-group-addon widthAuto flex align-items"
              v-if="hasAddOnSlot"
            >
              <slot name="addon">
                sadasdadasdasdasd
              </slot>
            </div>
          </div>
        </template>
      </slot>
      <div
        v-if="maxlength"
        :style="'color:' + charColor + ';font-size:14px;padding-top:5px'"
      >
        <span style="float:left;color:#989b9c;font-weight:bold;"></span>
          Min {{ maxlength }} Characters
        </span>
        <span style="float:right;">
          {{ value.length }} / {{ maxlength }} Characters
        </span>
      </div>
      <slot name="error-display" v-if="showError">
        <span
          class="help-block"
          v-if="
            ((form.errors.has(name) && hideHelpBlockIfNoErrors) ||
              !hideHelpBlockIfNoErrors) && form.errors.has(name)
          "
        >
          <strong> {{
            form.errors.get(name)
          }} </strong>
          <!--<span><i class="fa fa-times-circle" style="color: #b40020;font-size:30px;margin-right:10px;"></i></span><strong>{{ form.errors.get(name) }}</strong>-->
        </span>
      </slot>
      <!--
        <slot name="error-display">
	        <span class="help-block correct-display" v-show="form.errors.has(name)">
	            <span><i class="fa fa-check-circle" style="color: #47a647;;font-size:30px;margin-right:10px;"></i></span><span>You will receive access to InteDashboard until <br><strong>18 SEPTEMBER 2018</strong></spant
	        </span>
        </slot>
        -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["display", "form", "name", "options", "ariaLabel"],
  created() {
    this.init();
  },
  data() {
    return {
      min: null,
      max: null,
      decimal: -1,
      maxlength: null,
      minlength: null,
      charColor: "#6b9c5d",
      rows: null,
      placeholder: null,
      hasLabel: true,
      style: "",
      type: "text",
      cls: "form-group",
      value: "",
      tooltip: null,
      showError: true,
      htmlEditor: false,
      htmlEditorHeight: 250,
      hideHelpBlockIfNoErrors: false,
      id: "",
      nameLabel: "",
      autofocus: "",
      dateWidth: false,
      isTabbed: false,
      required: false,
    };
  },
  methods: {
    init() {
      this.value = _.get(this.form.model, this.name);
      this.showError = _.get(this, "options.showError", true);
      if (_.get(this, "options.type", false)) {
        this.type = _.get(this, "options.type", false);
        if (this.type == "number") {
          var max = _.get(this, "options.max", 99999999);
          this.max = max;
          var min = _.get(this, "options.min", -99999999);
          this.min = min;
          var decimal = _.get(this, "options.decimal", -1);
          this.decimal = decimal;
        } else if (this.type == "text" || this.type == "password") {
          var maxlength = _.get(this, "options.maxlength", false);
          if (maxlength) {
            this.maxlength = maxlength;
          }
        } else if (this.type == "text-area") {
          var rows = _.get(this, "options.rows", false);
          if (rows) {
            this.rows = rows;
          }
          var maxlength = _.get(this, "options.maxlength", false);
          if (maxlength) {
            this.maxlength = maxlength;
          }
          var minlength = _.get(this, "options.minlength", false);
          if (minlength) {
            this.minlength = minlength;
          }
          if (this.minlength) {
            if (this.value.length < this.minlength) {
              this.charColor = "#ff0202";
            }
          }
        }
      } else {
        //default type text
        var maxlength = _.get(this, "options.maxlength", false);
        if (maxlength) {
          this.maxlength = maxlength;
        }
      }
      //nameLabel
      this.id = _.get(this, "options.id", this.name);
      this.nameLabel = _.get(this, "options.name", this.name);
      //placeholder
      var placeholder = _.get(this, "options.placeholder", false);
      if (placeholder) {
        this.placeholder = placeholder;
      }
      //label
      var label = _.get(this, "options.hasLabel", true);
      this.hasLabel = label;

      //placeholder
      var cls = _.get(this, "options.cls", null);
      if (cls != null) {
        this.cls = cls;
      }
      //style
      var style = _.get(this, "options.style", null);
      if (style != null) {
        this.style = style;
      }
      //autofocus
      var autofocus = _.get(this, "options.autofocus", null);
      if (autofocus != null) {
        this.autofocus = autofocus;
      }
      //htmlEditor
      var htmlEditor = _.get(this, "options.htmlEditor", null);
      if (htmlEditor != null) {
        this.htmlEditor = htmlEditor;
        this.htmlEditorHeight = _.get(this.options, "htmlEditorHeight", 250);
      }
      //tooltip
      var tooltip = _.get(this, "options.tooltip", null);
      if (tooltip != null) {
        this.tooltip = tooltip;
        Vue.nextTick(function() {
          $('[data-toggle="tooltip"]').tooltip();
        });
      }

      var hideHelpBlockIfNoErrors = _.get(
        this,
        "options.hideHelpBlockIfNoErrors",
        null
      );
      if (hideHelpBlockIfNoErrors != null) {
        this.hideHelpBlockIfNoErrors = hideHelpBlockIfNoErrors;
      }

      //label
      var dateWidth = _.get(this, "options.dateWidth", false);
      this.dateWidth = dateWidth;

      //required
      var required = _.get(this, "options.required", false);
      if (required) {
        this.required = required;
      }
    },
    quantityUp() {
      if (this.form.isDisabled(this.name)) {
        return;
      }
      var oldValue = parseInt(this.value ? this.value : 0);
      if (oldValue >= parseInt(this.max)) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue + 1;
      }
      //console.log('quantityUp ' + newVal )
      //console.log('this is max value ' + this.max +' & this is min value ' + this.min )
      this.value = newVal;
      this.emit();
    },
    quantityDown() {
      if (this.form.isDisabled(this.name)) {
        return;
      }
      var oldValue = parseInt(this.value ? this.value : 0);
      if (oldValue <= this.min) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue - 1;
      }
      //console.log('quantityDown ' + newVal )
      this.value = newVal;
      this.emit();
    },
    isNumber(event) {
      var keysAllowed = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "Backspace",
        "Delete",
        //".",
      ];
      if(this.decimal>0){
        keysAllowed.push(".")
      }
      const keyPressed = event.key;
      if (!keysAllowed.includes(keyPressed)) {
        event.preventDefault();
      }
    },
    validateNumber() {
      this.value = this.value.replace(/[^0-9]|^0+(?!$)/g, "");
    },
    validateEmail() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let a = re.test(String(this.value).toLowerCase());

      if (!a) {
        this.form.errors.append(this.name, ["This should be a valid email"]);
      }
    },
    keyup(event) {
      this.value = $('[id="' + this.id + '"]').val();
      this.emit();
      this.$emit("keyup", event);
    },
    blur(event) {
      this.value = $('[id="' + this.id + '"]').val();
      this.emit();
      this.$emit("blur", event);
    },
    emit(emit) {
      if (this.type == "number") {
        if (this.decimal == -1) {
          this.value = Number(this.value);
        } else {
          this.value = Number(this.value).toFixed(this.decimal);
        }
        if (this.value < this.min) {
          this.value = this.min;
        }
        if (this.value > this.max) {
          this.value = this.max;
        }
        $('[id="' + this.id + '"]').val(this.value);
      }
      if (_.has(this.form.model, this.name)) {
        _.set(this.form.model, this.name, this.value);
        this.$emit("changed");
      }
    },
  },
  computed: {
    hasAddOnSlot() {
      return !!this.$slots["addon"];
    },
  },
  watch: {
    "form.model": {
      deep: true,
      handler(value, oldValue) {
        this.value = _.get(this.form.model, this.name, "");
      },
    },
    name: {
      handler(value, oldValue) {
        this.init();
      },
    },
    value: {
      handler(value, oldValue) {
        if (this.minlength) {
          if (this.value.length < this.minlength) {
            this.charColor = "#ff0202";
          } else {
            this.charColor = "#6b9c5d";
          }
        }
        if (this.htmlEditor) {
          this.form.errors.clear(name);
          this.emit();
        }
      },
    },
    options: {
      handler() {
        if (this.type == "number") {
          var max = _.get(this, "options.max", 999999999999999);
          this.max = max;
          var min = _.get(this, "options.min", -99999999999999);
          this.min = min;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.numberInput {
  position: relative;
}

.quantity-nav {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 10px;
  color: #222;
  z-index: 4;
  height: 100%;
  max-height: 100%;
}

.quantity-nav .disabled {
  color: #dfe3e9;
  cursor: not-allowed;
}

.quantity-button {
  min-height: 18px;
  height: 50%;
  display: flex;
  align-items: center;
  width: 22px;
  justify-content: center;
  // border: 1px solid ##dfe3e9;
  border: 1px solid #767676;
  background-image: linear-gradient(to bottom, #ffffff, #eff2f6);
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.quantity-button:last-child {
  // border-top: 1px solid #dfe3e9;
  border-top: 1px solid #767676;
}

.input-group-addon,
.input-group-addon:last-child {
  border-radius: 3px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border: 1px solid #d8d8d8;
  background-image: linear-gradient(to bottom, #ffffff, #f5f7f9);
}

.input-group input {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.iratPoints .numberInput {
  width: 110px;
}

.timerTopBar #durationHours-div .input-group,
.timerTopBar #durationMinutes-div .input-group {
  margin-bottom: 0;
  width: 122px;
}

input.iratDurationMinutes,
input.iratDurationHours,
input.tratDurationMinutes,
input.tratDurationHours,
input.applicationDurationMinutes,
input.applicationDurationHours,
input.evaluationDurationMinutes,
input.evaluationDurationHours {
  width: 64px;
}

input.iratDurationDays,
input.tratDurationDays,
input.applicationDurationDays,
input.evaluationDurationDays {
  width: 64px;
}

.fixedWidthNumber {
  width:64px !important;
}
</style>
